import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import tw from 'twin.macro';
import * as yup from 'yup';

import { isWorld } from '@/app/api/API-Url';
import { usePrepaidApplyMutation, usePrepaidCountriesQuery } from '@/app/api/prepaid';
import { getMobilePhone, setApplyData, setCardType } from '@/app/store/slices/app';
import { BodyText, Button, Checkbox, StepContentWrapper, Title } from '@/components';
import InternationalPhoneInput from '@/components/ui/input/international-phone-input';
import { filterPrepaidCountries } from '@/helper';

function PrepaidApplyPage() {
  const [countryFormatLength, setCountryFormatLength] = useState(11);
  const [isExeceptionCountry, setIsExeceptionCountry] = useState(false);
  const cardType = useLocation().pathname.split('/')[1];

  const [fetchApply, { isLoading, error, isSuccess }] = usePrepaidApplyMutation();
  const { data: countries } = usePrepaidCountriesQuery();

  const storedPhone = useSelector(getMobilePhone)?.replaceAll('+', '');
  const err = error?.data?.error;
  const dispatch = useDispatch();
  const schema = yup.object({
    mobile_phone: yup
      .string()
      .trim()
      .test('len', '', val => {
        if (isExeceptionCountry) {
          if (val.length !== countryFormatLength && val.length !== countryFormatLength + 1) {
            return false;
          } else {
            return true;
          }
        } else {
          return String(val).length === countryFormatLength && !(String(val).length > countryFormatLength);
        }
      })
      .required(),
    conditions: yup.bool().oneOf([true], 'Это поле обязательное').required()
  });

  const {
    control,
    setValue,
    getValues,
    formState: { isValid, errors },
    setError
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    shouldFocusError: false,
    defaultValues: { conditions: true }
  });
  const navigate = useNavigate();

  const handleClickApply = () => {
    const mobile_phone = '+' + getValues('mobile_phone');
    fetchApply({ mobile_phone });
  };
  useEffect(() => {
    if (err?.description?.mobile_phone) {
      setError('mobile_phone', { type: 'value', message: err?.description?.mobile_phone[0] });
    }
    if (String(err?.code).toLocaleLowerCase() === 'invalid_otp') {
      const mobile_phone = '+' + getValues('mobile_phone');
      dispatch(setApplyData({ mobile_phone }));
      navigate('/prepaid-card/verify');
    }
  }, [error]);

  useEffect(() => {
    if (getValues('mobile_phone')) {
      const mobile_phone = '+' + getValues('mobile_phone');
      dispatch(setApplyData({ mobile_phone }));
      isSuccess && navigate('/prepaid-card/verify');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (storedPhone) {
      setValue('mobile_phone', storedPhone, { shouldValidate: true });
    }
  }, []);
  useEffect(() => {
    dispatch(setCardType(cardType));
  }, [cardType, dispatch, useLocation().pathname]);
  return (
    <>
      <StepContentWrapper twStyles={tw`text-center`}>
        <Title text='Введите номер телефона' variant='bold' twStyle={tw`mt-[30px] sm:mt-[48px] mb-[10px]`} />
        <BodyText text={'к которому будет привязана карта'} twStyle={tw`text-secondary`} />
        <form noValidate tw='text-left max-w-[416px] mx-auto mb-[48px] mt-[24px]'>
          <div tw='flex flex-col gap-[24px] mb-[20px]'>
            <InternationalPhoneInput
              isExeceptionCountry={isExeceptionCountry}
              setIsExeceptionCountry={setIsExeceptionCountry}
              control={control}
              errors={errors}
              onlyCountries={filterPrepaidCountries(countries?.data)}
              country={''}
              setCountryFormatLength={setCountryFormatLength}
              setValue={setValue}
              key={countries?.data[0]?.code2}
            />
            <Checkbox
              control={control}
              name='conditions'
              label='Я соглашаюсь '
              link={{
                text: 'с условиями выпуска и обслуживания предоплаченных карт',
                href: `https://bankffin.kz/storage/docs/3mwPadiMysq01NAmQGb6LzyUH1WBEJ929P7GXIsX.pdf`
              }}
              rules={{ required: { value: true, message: 'Это поле не может быть пустым' } }}
              disabled={false}
            />
          </div>
        </form>
      </StepContentWrapper>
      <div tw='text-left sm:max-w-[416px] max-w-[350px] mx-auto mt-[48px]'>
        <Button
          variant='secondary'
          onClick={handleClickApply}
          loading={isLoading}
          disabled={!isValid || isLoading || isSuccess}
        >
          Далее
        </Button>
      </div>
    </>
  );
}

export default PrepaidApplyPage;
